import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";

export const AddSubject = ({ id, onAdd, label = "Add a subject" }) => {
  const [subjects, setSubjects] = useState([]);
  const [v, setV] = useState("");
  useEffect(() => {
    api.get("/homework/subjects").then((r) => setSubjects(Array.isArray(r.data) ? r.data.map((s) => s?.subject).filter(Boolean) : [])).catch(() => {});
  }, []);
  const add = (e) => { e.preventDefault(); const s = v.trim(); if (!s) return; onAdd(s.slice(0, 60)); setV(""); };
  return (
    <form data-testid={id} onSubmit={add} className="card p-4 sm:p-5">
      <p className="text-sm font-semibold text-slate-800">{label}</p>
      <p className="text-xs text-slate-600">Works on any day, including weekends and holidays.</p>
      <div className="mt-3 flex gap-2">
        <input data-testid={`${id}-input`} list={`${id}-list`} value={v} onChange={(e) => setV(e.target.value)} maxLength={60} placeholder="e.g. Chemistry"
          className="flex-1 min-w-0 h-11 rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 outline-none focus:border-gold-400" />
        <datalist id={`${id}-list`}>{subjects.map((s) => <option key={s} value={s} />)}</datalist>
        <button data-testid={`${id}-button`} disabled={!v.trim()} className="inline-flex items-center gap-1.5 h-11 rounded-xl bg-gold-400 px-4 text-sm font-bold text-black disabled:opacity-40"><Plus className="w-4 h-4" />Add</button>
      </div>
      {subjects.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {subjects.slice(0, 14).map((s) => (
            <button type="button" key={s} data-testid={`${id}-chip-${s.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => onAdd(s)} className="rounded-full border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700 hover:border-gold-400">{s}</button>
          ))}
        </div>
      )}
    </form>
  );
};
